<script setup>
// eslint-disable-next-line no-undef
const props = defineProps({
    icon: {
        type: String,
        default: null,
    },
    text: {
        type: String,
        default: 'loading ...',
    }
})
</script>

<template>
    <div class="tw-h-full tw-flex tw-items-center tw-justify-center">
        <div class="tw-flex tw-items-center tw-gap-2">
            <i class="pi tw-text-4xl" :class="props.icon"></i>
            {{ props.text }}
        </div>
    </div>
</template>
